import { IntlShape } from 'react-intl';

import { Currency } from '../types/currency';
import { InstantAvailability } from './checkInstantAvailability';

interface AvailabilityMessage {
  title: string;
  content: string;
}

function formatCurrencyAmount(
  value: string | undefined,
  intl: IntlShape
): string {
  if (!value) return '';
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  return intl.formatNumber(num, { maximumFractionDigits: 0 });
}

export function getInstantAvailabilityMessage(
  instantAvailability: InstantAvailability,
  currency: Currency,
  intl: IntlShape
): AvailabilityMessage | null {
  if (!instantAvailability.reason) {
    return null;
  }

  const formattedLimit = formatCurrencyAmount(
    instantAvailability.effectiveLimit,
    intl
  );

  switch (instantAvailability.reason) {
    case 'no_currency_instant_rate':
      return {
        title: '',
        content: intl.formatMessage(
          { id: 'loanType.instant.notAvailableForCurrency' },
          { currency }
        ),
      };

    case 'no_currency_period_instant_rate':
      return {
        title: intl.formatMessage({ id: 'loanType.instant.temporarilyUnavailable' }),
        content: intl.formatMessage({ id: 'loanType.instant.noCapacity' }),
      };

    case 'exceeds_currency_limit':
      return {
        title: intl.formatMessage({ id: 'loanType.instant.unavailable' }),
        content: intl.formatMessage(
          { id: 'loanType.instant.limitedTo' },
          { limit: formattedLimit, currency }
        ),
      };

    case 'exceeds_ticket_capacity':
      return {
        title: intl.formatMessage({ id: 'loanType.instant.unavailable' }),
        content: intl.formatMessage(
          { id: 'loanType.instant.remaining' },
          { remaining: formattedLimit, currency }
        ),
      };

    default:
      return null;
  }
}
